export default __webpack_public_path__ + "static/media/mainan.dd894baa.png";